import {AD_IDS_ITEM} from '@/app/main/authentication/pages/SignUp/models/constants';

export const buildAmplifyClientMetadata = (): string | undefined => {
  try {
    const adIds = JSON.parse(localStorage.getItem(AD_IDS_ITEM) || '{}');
    if (Object.keys(adIds).length === 0) return undefined;
    return JSON.stringify(adIds);
  } catch {
    return undefined;
  }
};
